module.exports = __webpack_public_path__ + "static/media/Logo.facab906.svg";